<template>
  <MobileMenu
    :isShop="shop"
    :primaryLinks="primaryLinks"
    :secondaryLinks="secondaryLinks"
  />
</template>

<script>
import MobileMenu from "../../components/MobileMenu/MobileMenu.vue";

export default {
  name: "app",
  components: {
    MobileMenu
  },
  data() {
    return {
      shop: this.$options._parentVnode.data.props.shop,
      primaryLinks: JSON.parse(
        this.$options._parentVnode.data.props.primaryNav || "[]"
      ),
      secondaryLinks: JSON.parse(
        this.$options._parentVnode.data.props.secondaryNav || "[]"
      )
    };
  }
};
</script>
